import { render, staticRenderFns } from "./mrecBannerMiddle.vue?vue&type=template&id=159cf49e&scoped=true&"
import script from "./mrecBannerMiddle.vue?vue&type=script&lang=js&"
export * from "./mrecBannerMiddle.vue?vue&type=script&lang=js&"
import style0 from "./mrecBannerMiddle.vue?vue&type=style&index=0&id=159cf49e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159cf49e",
  null
  
)

export default component.exports